import React, { useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Textarea } from '../components/ui/textarea';
import { Phone, MapPin, MessageCircle } from 'lucide-react';
import { useToast } from '../hooks/use-toast';
import { Toaster } from '../components/ui/toaster';

const ContactPage = () => {
  const { toast } = useToast();
  const [formData, setFormData] = useState({
    nom: '',
    email: '',
    telephone: '',
    ville: '',
    message: ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    toast({
      title: "Message envoyé!",
      description: "Nous vous contacterons dans les plus brefs délais.",
    });
    setFormData({ nom: '', email: '', telephone: '', ville: '', message: '' });
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <div className="contact-page">
      <Header />
      <div className="contact-container">
        <div className="contact-hero">
          <h1>Contactez-nous</h1>
          <p>Disponible 24h/24 et 7j/7 pour vous accompagner à Bruxelles</p>
        </div>

        <div className="contact-content">
          <div className="contact-info">
            <h2>Informations de contact</h2>
            
            <div className="info-item">
              <Phone className="icon" />
              <div>
                <h3>Téléphone</h3>
                <p>04 65 61 94 11</p>
              </div>
            </div>

            <div className="info-item">
              <MessageCircle className="icon" />
              <div>
                <h3>WhatsApp</h3>
                <a href="https://wa.me/32465619411" target="_blank" rel="noopener noreferrer">
                  Contactez via WhatsApp
                </a>
              </div>
            </div>

            <div className="info-item">
              <MapPin className="icon" />
              <div>
                <h3>Localisation</h3>
                <p>Avenue Louise 250, 1050 Bruxelles</p>
                <p className="cities">Bruxelles • Ixelles • Schaerbeek • Anderlecht • Molenbeek</p>
              </div>
            </div>
          </div>

          <div className="contact-form-wrapper">
            <h2>Envoyez-nous un message</h2>
            <form onSubmit={handleSubmit} className="contact-form">
              <div className="form-group">
                <label htmlFor="nom">Nom complet *</label>
                <Input
                  id="nom"
                  name="nom"
                  value={formData.nom}
                  onChange={handleChange}
                  required
                  placeholder="Votre nom"
                />
              </div>

              <div className="form-group">
                <label htmlFor="email">Email *</label>
                <Input
                  id="email"
                  name="email"
                  type="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  placeholder="votre@email.be"
                />
              </div>

              <div className="form-group">
                <label htmlFor="telephone">Téléphone</label>
                <Input
                  id="telephone"
                  name="telephone"
                  type="tel"
                  value={formData.telephone}
                  onChange={handleChange}
                  placeholder="+32 ..."
                />
              </div>

              <div className="form-group">
                <label htmlFor="ville">Commune</label>
                <Input
                  id="ville"
                  name="ville"
                  value={formData.ville}
                  onChange={handleChange}
                  placeholder="Bruxelles, Ixelles, Schaerbeek..."
                />
              </div>

              <div className="form-group">
                <label htmlFor="message">Message *</label>
                <Textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  rows={6}
                  placeholder="Décrivez votre situation..."
                />
              </div>

              <Button type="submit" className="submit-btn">
                Envoyer le message
              </Button>
            </form>
          </div>
        </div>
      </div>
      <Footer />
      <Toaster />
    </div>
  );
};

export default ContactPage;
